import { combineReducers } from "@reduxjs/toolkit";
import userReducer from "./features/userSlice";
import trackHRReducer from "./features/trackhrdataslice";
import trackhrCategory from "./features/categoryslice";
import userData from "./features/UserDataslice";


const appReducer = combineReducers({
  users: userReducer,
  trackhrdata: trackHRReducer,
  trackhrcategory: trackhrCategory,
  userData: userData
});


const rootReducer = (state, action) => {
  if (action.type === "RESET_STORE") {
    state = undefined;  
  }
  return appReducer(state, action);
};

export default rootReducer;
